import axios from 'axios';

// ריק = אותו דומיין. בפיתוח src/setupProxy.js מעביר /api לשרת המקומי
const BaseUrl = process.env.REACT_APP_API_URL || '';
const APP_ID = 1;

// האתר ציבורי ובלי התחברות, לכן לא נשלח טוקן.
// מחזיר את תשובת ה-SP כמו שהיא: [[{code,msg}], [...rows], ...]
const requestData = async (action, params) => {
  const now = new Date();
  const createAt = new Date(now - now.getTimezoneOffset() * 60000).toISOString().slice(0, 19).replace('T', ' ');
  const response = await axios.post(`${BaseUrl}/api/ver1/run`, { action, params: { ...params } },
                                    { headers: { appId: APP_ID, createAt } });
  return response.data;
};

const utils = { requestData };

export default utils;
